import { Component, inject, signal } from '@angular/core';

import { of } from 'rxjs';

import {
  CamNotificationDataService,
  CamNotificationService,
  ENotificationCode,
  ItemComponent,
  NotificationBoxComponent,
  NotificationInlineComponent,
} from '@camelot/notification';

import { TestIdDirective } from '@camelot/testing-harness';
import { notificationMock } from '../notification/notification.case';

export const notificationSpy = {
  markAsReadCalls: signal(0),
};

const dataServiceMock = {
  computeKey: () => 'all',
  count: { get$: () => of(1) },
  fetchNotifications$: () => of([notificationMock]),
  fetchNumberOfNotifications$: () => of(1),
  isRead$: () => {
    notificationSpy.markAsReadCalls.update(count => count + 1);
    return of(true);
  },
  list: { get$: () => of([notificationMock]) },
  markAsRead$: () => {
    notificationSpy.markAsReadCalls.update(count => count + 1);
    return of(true);
  },
};

@Component({
    imports: [ItemComponent, NotificationBoxComponent, NotificationInlineComponent, TestIdDirective],
    providers: [{ provide: CamNotificationDataService, useValue: dataServiceMock }],
    template: `
    <cam-notification-box camTestId="nf-box" />
    <button camTestId="nf-push" (click)="this.push()">push toast</button>

    <cam-notification-inline camTestId="nf-inline" message="inline message" (askClose)="this.closed.set(true)" />
    <div camTestId="nf-inline-closed">{{ this.closed() }}</div>

    <cam-notification-item camTestId="nf-item" [notification]="this.notification" />
    <div camTestId="nf-read-calls">{{ this.readCalls() }}</div>
  `
})
export class NotificationFlowsCase {
  public closed = signal(false);
  public notification = notificationMock;
  public readCalls = notificationSpy.markAsReadCalls;

  private readonly _notificationService = inject(CamNotificationService);

  public push(): void {
    this._notificationService.addNotification('Hello toast', ENotificationCode.success);
  }
}
